// extracted by mini-css-extract-plugin
export default {"ssoFailureContainer":"ssoFailure_ssoFailureContainer__R2ghZ","logo":"ssoFailure_logo__5vZni","title":"ssoFailure_title__L1ykj"};